//
import Service from '@/services/api/service'
import AssetDiscountModel from '@/models/HumanResource/HrAssetDiscount'

//
import filters from './filters'
import headers from './headers'

//
export default class extends Service {

    //
    static filters  = filters
    static headers  = headers
    static includes = [
        'hr_asset_discount_type',
    ]
    
    //
    static model = AssetDiscountModel
}
